import React from 'react';
import styles from '../styles/BrandCard.module.scss';

export function BrandCard({brand}) {
    const accessToken = localStorage.getItem('userAccessToken');
    const refreshToken = localStorage.getItem('userRefreshToken');
    const firstLetter = brand.title?.slice(0,1).toUpperCase();
  return (
    <a href={`${brand.url}/authorization/${accessToken}/${refreshToken}`} className={styles.card}>
        {
            brand.icon_url ?
                <img src={brand.icon_url} alt={'icon'} width={60} height={60}/>
            :
                <div className={styles.brand_icon}>
                    <h1>
                        {firstLetter}
                    </h1>
                </div>
        }
        <p>
            {brand.title}
        </p>
    </a>
  )
}
